import React from 'react';
import ReactDOM from 'react-dom/client';
import 'assets/index.scss';
import App from 'components/App';
import * as serviceWorker from './serviceWorker';
import config from 'config/config';
import Axios from 'axios';
import 'semantic-ui-css/semantic.min.css';

// Set axios base and timeout so hanging API calls fail instead of waiting forever
Axios.defaults.baseURL = config.API_BASE_URL;
Axios.defaults.timeout = 20000;

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

serviceWorker.unregister();
